import { Component, computed, inject, OnInit } from '@angular/core';
import { RouterLink } from "@angular/router";
import { SignalsStoreService } from '../../../shared/signals-store.service';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-main-about-us',
    imports: [
        RouterLink
    ],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit {

  private signalsStoreService = inject(SignalsStoreService);
  private meta = inject(Meta);
  private title = inject(Title)

  logoVersionNumber = computed(() => this.signalsStoreService.logoVersionNumber());

  ngOnInit(): void {
    this.setUpSEOTags();
  }


  private setUpSEOTags() {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = 'pages/about-us/main'
    const component = 'About Us'
    const title = `${component} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }

}
